import { Skeleton } from 'antd';
import styled from 'styled-components';

export default styled(Skeleton)`
	// Add your styles here
`;
